import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

export function useIsMobile(): boolean {
  const theme = useTheme();
  // { noSsr: true } avoids server/client mismatch (choose strategy appropriate to your app)
  return useMediaQuery(theme.breakpoints.down('lg'), { noSsr: true });
}
